import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/dash/Ui";
import { DateFilter, DEFAULT_RANGE } from "@/components/dash/DateFilter";
import { StatsView } from "@/components/dash/StatsView";
import { RecentClicks } from "@/components/dash/RecentClicks";

export default function Overview() {
  const [range, setRange] = useState(DEFAULT_RANGE);
  const [gran, setGran] = useState("day");
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/stats", { params: { start: range.start, end: range.end, granularity: gran } }).then((r) => setS(r.data));
  }, [range, gran]);

  return (
    <div>
      <PageHeader eyebrow="Analytics" title="Overview">
        <DateFilter value={range} onChange={setRange} />
      </PageHeader>
      <StatsView s={s} gran={gran} setGran={setGran} />
      <RecentClicks range={range} />
    </div>
  );
}
